import {
  Modal,
  Box,
  Typography,
  Switch,
  Button,
  IconButton,
  Stack,
  Divider,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CommentIcon from "@mui/icons-material/Comment";
import ChatIcon from "@mui/icons-material/Chat";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import WorkIcon from "@mui/icons-material/Work";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { Postrequestcall } from "../../request/Postrequest";
import { FETCH_USER_SETTINGS, UPDATE_NOTIFICATION_SETTINGS } from "../../constant/Apipath";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Loader from "../../common/Loader";
import { English } from "../../constant/EnglishFallback";
import { BIBlue } from "../../assets/helpers";

export default function NotificationSettingModal({
  notificationModal,
  handelNotificationSettingModalClose
}) {
  const [notificationSettings, setNotificationSettings] = useState({
    isNotifyPostComment: false,
    isNotifyChatGroup: false,
    isNotifyConnectRequest: false,
    isNotifySafetyTicket: false,
    isNotifyUserProfile: false,
    isNotifyUserExperience: false,
    isNotifyUserQuestion: false,
    isNotifyJobSearch: false
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isUpdateLoading, setIsUpdateLoading] = useState(false);
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);
  const [selectedNotificationInfo, setSelectedNotificationInfo] = useState(null);
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.Settings || {};
  const {
    TEXT_NOTIFICATION_SETTINGS = English.Settings.TEXT_NOTIFICATION_SETTINGS,
    TEXT_COMMENTS = English.Settings.TEXT_COMMENTS,
    TEXT_CHAT_NOTIFICATIONS = English.Settings.TEXT_CHAT_NOTIFICATIONS,
    TEXT_CONNECTION_REQUEST = English.Settings.TEXT_CONNECTION_REQUEST,
    TEXT_SUBMIT = English.Settings.TEXT_SUBMIT,
    TEXT_COMMUNICATION = English.Settings.TEXT_COMMUNICATION,
    TEXT_COMMENT_NOTIFICATIONS_DESC = English.Settings.TEXT_COMMENT_NOTIFICATIONS_DESC,
    TEXT_CHAT_NOTIFICATIONS_DESC = English.Settings.TEXT_CHAT_NOTIFICATIONS_DESC,
    TEXT_CONNECTION_REQUEST_DESC = English.Settings.TEXT_CONNECTION_REQUEST_DESC,
    TEXT_SAFETY_TICKETS = English.Settings.TEXT_SAFETY_TICKETS,
    TEXT_TICKETS_EXPIRY = English.Settings.TEXT_TICKETS_EXPIRY,
    TEXT_TICKET_EXPIRATION_REMINDERS = English.Settings.TEXT_TICKET_EXPIRATION_REMINDERS,
    TEXT_PROFILE_UPDATES = English.Settings.TEXT_PROFILE_UPDATES,
    TEXT_PROFILE_UPDATES_DESC = English.Settings.TEXT_PROFILE_UPDATES_DESC,
    TEXT_WORK_EXPERIENCE_UPDATES = English.Settings.TEXT_WORK_EXPERIENCE_UPDATES,
    TEXT_WORK_EXPERIENCE_DESC = English.Settings.TEXT_WORK_EXPERIENCE_DESC,
    TEXT_JOB_SEARCH_ALERTS = English.Settings.TEXT_JOB_SEARCH_ALERTS,
    TEXT_JOB_SEARCH_ALERTS_LABEL = English.Settings.TEXT_JOB_SEARCH_ALERTS_LABEL,
    TEXT_JOB_SEARCH_ALERTS_DESC = English.Settings.TEXT_JOB_SEARCH_ALERTS_DESC,
    TEXT_QUIZZES = English.Settings.TEXT_QUIZZES,
    TEXT_QUIZ_NOTIFICATIONS = English.Settings.TEXT_QUIZ_NOTIFICATIONS,
    TEXT_QUIZ_NOTIFICATIONS_DESC = English.Settings.TEXT_QUIZ_NOTIFICATIONS_DESC,
    TEXT_NOTIFICATION_DETAILS = English.Settings.TEXT_NOTIFICATION_DETAILS,
    TEXT_COMMENT_NOTIFICATIONS_TIMING = English.Settings.TEXT_COMMENT_NOTIFICATIONS_TIMING,
    TEXT_COMMENT_NOTIFICATIONS_DETAIL = English.Settings.TEXT_COMMENT_NOTIFICATIONS_DETAIL,
    TEXT_NEW_MESSAGE = English.Settings.TEXT_NEW_MESSAGE,
    TEXT_NEW_MESSAGE_DETAIL = English.Settings.TEXT_NEW_MESSAGE_DETAIL,
    TEXT_JOINED_PROJECT_GROUP = English.Settings.TEXT_JOINED_PROJECT_GROUP,
    TEXT_JOINED_PROJECT_GROUP_DETAIL = English.Settings.TEXT_JOINED_PROJECT_GROUP_DETAIL,
    TEXT_IMMEDIATELY = English.Settings.TEXT_IMMEDIATELY,
    TEXT_IMMEDIATELY_DETAIL = English.Settings.TEXT_IMMEDIATELY_DETAIL,
    TEXT_THREE_DAYS_REMINDER = English.Settings.TEXT_THREE_DAYS_REMINDER,
    TEXT_THREE_DAYS_REMINDER_DETAIL = English.Settings.TEXT_THREE_DAYS_REMINDER_DETAIL,
    TEXT_WEEKLY_SUMMARY = English.Settings.TEXT_WEEKLY_SUMMARY,
    TEXT_WEEKLY_SUMMARY_DETAIL = English.Settings.TEXT_WEEKLY_SUMMARY_DETAIL,
    TEXT_FIFTEEN_DAYS_BEFORE = English.Settings.TEXT_FIFTEEN_DAYS_BEFORE,
    TEXT_FIFTEEN_DAYS_BEFORE_DETAIL = English.Settings.TEXT_FIFTEEN_DAYS_BEFORE_DETAIL,
    TEXT_THIRTY_DAYS_BEFORE = English.Settings.TEXT_THIRTY_DAYS_BEFORE,
    TEXT_THIRTY_DAYS_BEFORE_DETAIL = English.Settings.TEXT_THIRTY_DAYS_BEFORE_DETAIL,
    TEXT_ON_EXPIRATION_DATE = English.Settings.TEXT_ON_EXPIRATION_DATE,
    TEXT_ON_EXPIRATION_DATE_DETAIL = English.Settings.TEXT_ON_EXPIRATION_DATE_DETAIL,
    TEXT_TWO_WEEKS_AFTER_EXPIRATION = English.Settings.TEXT_TWO_WEEKS_AFTER_EXPIRATION,
    TEXT_TWO_WEEKS_AFTER_EXPIRATION_DETAIL = English.Settings.TEXT_TWO_WEEKS_AFTER_EXPIRATION_DETAIL,
    TEXT_DAY_ONE_AFTER_SIGNUP = English.Settings.TEXT_DAY_ONE_AFTER_SIGNUP,
    TEXT_DAY_ONE_AFTER_SIGNUP_DETAIL = English.Settings.TEXT_DAY_ONE_AFTER_SIGNUP_DETAIL,
    TEXT_FIFTEEN_DAYS_AFTER_SIGNUP = English.Settings.TEXT_FIFTEEN_DAYS_AFTER_SIGNUP,
    TEXT_FIFTEEN_DAYS_AFTER_SIGNUP_DETAIL = English.Settings.TEXT_FIFTEEN_DAYS_AFTER_SIGNUP_DETAIL,
    TEXT_MONTHLY_REMINDER_FIRST = English.Settings.TEXT_MONTHLY_REMINDER_FIRST,
    TEXT_MONTHLY_REMINDER_FIRST_DETAIL = English.Settings.TEXT_MONTHLY_REMINDER_FIRST_DETAIL,
    TEXT_TWO_DAYS_AFTER_SIGNUP = English.Settings.TEXT_TWO_DAYS_AFTER_SIGNUP,
    TEXT_TWO_DAYS_AFTER_SIGNUP_DETAIL = English.Settings.TEXT_TWO_DAYS_AFTER_SIGNUP_DETAIL,
    TEXT_SIXTEEN_DAYS_AFTER_SIGNUP = English.Settings.TEXT_SIXTEEN_DAYS_AFTER_SIGNUP,
    TEXT_SIXTEEN_DAYS_AFTER_SIGNUP_DETAIL = English.Settings.TEXT_SIXTEEN_DAYS_AFTER_SIGNUP_DETAIL,
    TEXT_MONTHLY_REMINDER_SECOND = English.Settings.TEXT_MONTHLY_REMINDER_SECOND,
    TEXT_MONTHLY_REMINDER_SECOND_DETAIL = English.Settings.TEXT_MONTHLY_REMINDER_SECOND_DETAIL,
    TEXT_NEW_JOB_ALERTS = English.Settings.TEXT_NEW_JOB_ALERTS,
    TEXT_NEW_JOB_ALERTS_DETAIL = English.Settings.TEXT_NEW_JOB_ALERTS_DETAIL,
    TEXT_DAILY_QUIZ_NOTIFICATIONS = English.Settings.TEXT_DAILY_QUIZ_NOTIFICATIONS,
    TEXT_DAILY_QUIZ_NOTIFICATIONS_DETAIL = English.Settings.TEXT_DAILY_QUIZ_NOTIFICATIONS_DETAIL,
    TEXT_SAVE_CHANGES = English.Settings.TEXT_SAVE_CHANGES,
    TEXT_SAVING = English.Settings.TEXT_SAVING,
    TEXT_OK = English.Settings.TEXT_OK
  } = LanguageData;

  useEffect(() => {
    fetchNotificationSettings();
  }, []);

  const fetchNotificationSettings = async () => {
    try {
      setIsLoading(true);
      const notification_Object = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: "",
        IncludeRecordNr: true,
        TypeOfObjectReturned: "",
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            userId: Number(loginData?.userInformation?.UserId)
          }
        ]
      };
      const response = await Postrequestcall(
        FETCH_USER_SETTINGS,
        notification_Object,
        loginData?.accessToken
      );
      setNotificationSettings(response.data.data?.[0]);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(
        "fetchNotificationSettings-> Error While Fetching User Notification Setting: ",
        error
      );
    }
  };

  const handelUpdateNotification = async () => {
    try {
      setIsUpdateLoading(true);
      const update_notification_obj = {
        Id: notificationSettings.id,
        UserId: Number(loginData?.userInformation?.UserId),
        IsNotifyChatGroup: notificationSettings.isNotifyChatGroup,
        IsNotifyPostComment: notificationSettings.isNotifyPostComment,
        IsNotifyConnectRequest: notificationSettings.isNotifyConnectRequest,
        IsNotifySafetyTicket: notificationSettings.isNotifySafetyTicket,
        IsNotifyUserProfile: notificationSettings.isNotifyUserProfile,
        IsNotifyUserExperience: notificationSettings.isNotifyUserExperience,
        IsNotifyUserQuestion: notificationSettings.isNotifyUserQuestion,
        IsNotifyJobSearch: notificationSettings.isNotifyJobSearch
      };

      const updateresponse = await Postrequestcall(
        UPDATE_NOTIFICATION_SETTINGS,
        update_notification_obj,
        loginData?.accessToken
      );
      setNotificationSettings(updateresponse.data.data?.[0]);
      setIsUpdateLoading(false);
    } catch (error) {
      setIsUpdateLoading(false);
      console.log(
        "handelUpdateNotification-> Error While Updating User Notification Setting: ",
        error
      );
    }
  };

  const handleToggle = (name) => {
    setNotificationSettings((prev) => ({
      ...prev,
      [name]: !prev[name]
    }));
  };

  const notificationCategories = [
    {
      title: TEXT_COMMUNICATION,
      options: [
        {
          name: "isNotifyPostComment",
          label: TEXT_COMMENTS,
          description: TEXT_COMMENT_NOTIFICATIONS_DESC,
          icon: <CommentIcon sx={{ color: "#1e3a8a" }} />,
          details: {
            title: TEXT_NOTIFICATION_DETAILS,
            items: [
              {
                timing: TEXT_COMMENT_NOTIFICATIONS_TIMING,
                description: TEXT_COMMENT_NOTIFICATIONS_DETAIL
              }
            ]
          }
        },
        {
          name: "isNotifyChatGroup",
          label: TEXT_CHAT_NOTIFICATIONS,
          description: TEXT_CHAT_NOTIFICATIONS_DESC,
          icon: <ChatIcon sx={{ color: "#1e3a8a" }} />,
          details: {
            title: TEXT_NOTIFICATION_DETAILS,
            items: [
              {
                timing: TEXT_NEW_MESSAGE,
                description: TEXT_NEW_MESSAGE_DETAIL
              },
              {
                timing: TEXT_JOINED_PROJECT_GROUP,
                description: TEXT_JOINED_PROJECT_GROUP_DETAIL
              }
            ]
          }
        },
        {
          name: "isNotifyConnectRequest",
          label: TEXT_CONNECTION_REQUEST,
          description: TEXT_CONNECTION_REQUEST_DESC,
          icon: <PersonAddIcon sx={{ color: "#1e3a8a" }} />,
          details: {
            title: TEXT_NOTIFICATION_DETAILS,
            items: [
              {
                timing: TEXT_IMMEDIATELY,
                description: TEXT_IMMEDIATELY_DETAIL
              },
              {
                timing: TEXT_THREE_DAYS_REMINDER,
                description: TEXT_THREE_DAYS_REMINDER_DETAIL
              },
              {
                timing: TEXT_WEEKLY_SUMMARY,
                description: TEXT_WEEKLY_SUMMARY_DETAIL
              }
            ]
          }
        }
      ]
    },
    {
      title: TEXT_SAFETY_TICKETS,
      options: [
        {
          name: "isNotifySafetyTicket",
          label: TEXT_TICKETS_EXPIRY,
          description: TEXT_TICKET_EXPIRATION_REMINDERS,
          icon: <ConfirmationNumberIcon sx={{ color: "#1e3a8a" }} />,
          details: {
            title: TEXT_NOTIFICATION_DETAILS,
            items: [
              {
                timing: TEXT_FIFTEEN_DAYS_BEFORE,
                description: TEXT_FIFTEEN_DAYS_BEFORE_DETAIL
              },
              {
                timing: TEXT_THIRTY_DAYS_BEFORE,
                description: TEXT_THIRTY_DAYS_BEFORE_DETAIL
              },
              {
                timing: TEXT_ON_EXPIRATION_DATE,
                description: TEXT_ON_EXPIRATION_DATE_DETAIL
              },
              {
                timing: TEXT_TWO_WEEKS_AFTER_EXPIRATION,
                description: TEXT_TWO_WEEKS_AFTER_EXPIRATION_DETAIL
              }
            ]
          }
        }
      ]
    },
    {
      title: TEXT_PROFILE_UPDATES,
      options: [
        {
          name: "isNotifyUserProfile",
          label: TEXT_PROFILE_UPDATES,
          description: TEXT_PROFILE_UPDATES_DESC,
          icon: <BusinessCenterIcon sx={{ color: "#1e3a8a" }} />,
          details: {
            title: TEXT_NOTIFICATION_DETAILS,
            items: [
              {
                timing: TEXT_DAY_ONE_AFTER_SIGNUP,
                description: TEXT_DAY_ONE_AFTER_SIGNUP_DETAIL
              },
              {
                timing: TEXT_FIFTEEN_DAYS_AFTER_SIGNUP,
                description: TEXT_FIFTEEN_DAYS_AFTER_SIGNUP_DETAIL
              },
              {
                timing: TEXT_MONTHLY_REMINDER_FIRST,
                description: TEXT_MONTHLY_REMINDER_FIRST_DETAIL
              }
            ]
          }
        },
        {
          name: "isNotifyUserExperience",
          label: TEXT_WORK_EXPERIENCE_UPDATES,
          description: TEXT_WORK_EXPERIENCE_DESC,
          icon: <WorkIcon sx={{ color: "#1e3a8a" }} />,
          details: {
            title: TEXT_NOTIFICATION_DETAILS,
            items: [
              {
                timing: TEXT_TWO_DAYS_AFTER_SIGNUP,
                description: TEXT_TWO_DAYS_AFTER_SIGNUP_DETAIL
              },
              {
                timing: TEXT_SIXTEEN_DAYS_AFTER_SIGNUP,
                description: TEXT_SIXTEEN_DAYS_AFTER_SIGNUP_DETAIL
              },
              {
                timing: TEXT_MONTHLY_REMINDER_SECOND,
                description: TEXT_MONTHLY_REMINDER_SECOND_DETAIL
              }
            ]
          }
        }
      ]
    },
    {
      title: TEXT_JOB_SEARCH_ALERTS,
      options: [
        {
          name: "isNotifyJobSearch",
          label: TEXT_JOB_SEARCH_ALERTS_LABEL,
          description: TEXT_JOB_SEARCH_ALERTS_DESC,
          icon: <BusinessCenterIcon sx={{ color: "#1e3a8a" }} />,
          details: {
            title: TEXT_NOTIFICATION_DETAILS,
            items: [
              {
                timing: TEXT_NEW_JOB_ALERTS,
                description: TEXT_NEW_JOB_ALERTS_DETAIL
              }
            ]
          }
        }
      ]
    },
    {
      title: TEXT_QUIZZES,
      options: [
        {
          name: "isNotifyUserQuestion",
          label: TEXT_QUIZ_NOTIFICATIONS,
          description: TEXT_QUIZ_NOTIFICATIONS_DESC,
          icon: <AssignmentIcon sx={{ color: "#1e3a8a" }} />,
          details: {
            title: TEXT_NOTIFICATION_DETAILS,
            items: [
              {
                timing: TEXT_DAILY_QUIZ_NOTIFICATIONS,
                description: TEXT_DAILY_QUIZ_NOTIFICATIONS_DETAIL
              }
            ]
          }
        }
      ]
    }
  ];

  const handleOpenInfoDialog = (option) => {
    setSelectedNotificationInfo(option);
    setInfoDialogOpen(true);
  };

  const handleCloseInfoDialog = () => {
    setInfoDialogOpen(false);
    setSelectedNotificationInfo(null);
  };

  const NotificationItem = ({ option }) => (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        py: 2,
        px: 2,
        "&:hover": {
          bgcolor: "rgba(0, 0, 0, 0.02)"
        }
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, flex: 1 }}>
        <Avatar
          sx={{
            bgcolor: "#e8eaf6",
            width: 40,
            height: 40
          }}
        >
          {option.icon}
        </Avatar>
        <Box sx={{ flex: 1 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <Typography variant="body1" sx={{ fontWeight: 500, color: "#000" }}>
              {option.label}
            </Typography>
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                handleOpenInfoDialog(option);
              }}
              sx={{ padding: 0 }}
            >
              <InfoOutlinedIcon sx={{ fontSize: 16, color: "#9e9e9e" }} />
            </IconButton>
          </Box>
          <Typography variant="body2" sx={{ color: "#757575", fontSize: "0.875rem" }}>
            {option.description}
          </Typography>
        </Box>
      </Box>
      <Switch
        checked={notificationSettings?.[option.name] || false}
        onChange={() => handleToggle(option.name)}
        sx={{
          "& .MuiSwitch-switchBase.Mui-checked": {
            color: BIBlue
          },
          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
            backgroundColor: BIBlue
          }
        }}
      />
    </Box>
  );

  return (
    <>
      <Modal open={notificationModal} onClose={handelNotificationSettingModalClose}>
        <Box className="user-modal-responsive" sx={{ maxHeight: "90vh", overflow: "auto" }}>
          {isLoading ? (
            <Box sx={{ height: "250px" }}>
              <Loader />
            </Box>
          ) : (
            <>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  mb: 3
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  {TEXT_NOTIFICATION_SETTINGS}
                </Typography>
                <IconButton onClick={handelNotificationSettingModalClose}>
                  <CloseIcon />
                </IconButton>
              </Box>

              <Stack spacing={3}>
                {notificationCategories.map((category, categoryIdx) => (
                  <Box key={categoryIdx}>
                    <Typography
                      variant="caption"
                      sx={{
                        color: "#9e9e9e",
                        fontWeight: 600,
                        letterSpacing: "0.5px",
                        mb: 1,
                        display: "block"
                      }}
                    >
                      {category.title}
                    </Typography>
                    <Box
                      sx={{
                        bgcolor: "#fff",
                        borderRadius: 2,
                        border: "1px solid #e0e0e0",
                        overflow: "hidden"
                      }}
                    >
                      {category.options.map((option, optionIdx) => (
                        <Box key={optionIdx}>
                          <NotificationItem option={option} />
                          {optionIdx < category.options.length - 1 && (
                            <Divider sx={{ mx: 2 }} />
                          )}
                        </Box>
                      ))}
                    </Box>
                  </Box>
                ))}

                <Button
                  disabled={isUpdateLoading}
                  fullWidth
                  variant="contained"
                  sx={{
                    mt: 2,
                    bgcolor: BIBlue,
                    color: "#fff",
                    textTransform: "none",
                    fontWeight: 500,
                    boxShadow: "none",
                    "&:hover": {
                      bgcolor: "#093eeeff",
                      boxShadow: "none"
                    },
                    "&.Mui-disabled": {
                      bgcolor: "#e0e0e0",
                      color: "#757575"
                    }
                  }}
                  onClick={async () => {
                    await handelUpdateNotification();
                    handelNotificationSettingModalClose();
                  }}
                >
                  {isUpdateLoading ? TEXT_SAVING : TEXT_SAVE_CHANGES}
                </Button>
              </Stack>
            </>
          )}
        </Box>
      </Modal>

      <Dialog
        open={infoDialogOpen}
        onClose={handleCloseInfoDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            p: 0.5
          }
        }}
      >
        <DialogTitle sx={{ fontWeight: 600, fontSize: "1rem", pb: 1 }}>
          {selectedNotificationInfo?.details?.title || TEXT_NOTIFICATION_DETAILS}
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2.5} sx={{ pt: 1 }}>
            {selectedNotificationInfo?.details?.items?.map((item, index) => (
              <Box key={index}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: 600, color: "#000", mb: 0.5 }}
                >
                  {index + 1}. {item.timing}
                </Typography>
                <Typography variant="body2" sx={{ color: "#666", lineHeight: 1.6 }}>
                  {item.description}
                </Typography>
              </Box>
            ))}
          </Stack>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={handleCloseInfoDialog}
            variant="contained"
            fullWidth
            sx={{
              bgcolor: BIBlue,
              color: "#fff",
              textTransform: "none",
              borderRadius: 2,
              "&:hover": {
                bgcolor: "#093eeeff"
              }
            }}
          >
            {TEXT_OK}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
